<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="公司名称" prop="commercial_id" v-if="commercials.length > 0">
                <el-select v-model="queryForm.commercial_id" placeholder="全部" v-if="commercials.length > 1" @change="getShopList()">
                    <el-option v-for="item in commercials" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
                <el-input type="text" :value="commercials[0].name" disabled v-if="commercials.length == 1"></el-input>
            </el-form-item>
            <el-form-item label="店铺名称" prop="shop_id" v-if="shops.length > 0">
                <el-select
                        v-model="queryForm.shop_id"
                        filterable
                        remote
                        clearable
                        :remote-method="remoteShopMethod"
                        placeholder="请输入店铺">
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="配送类型" prop="orderType">-->
<!--                <el-select v-model="queryForm.orderType" placeholder="请选择">-->
<!--                    <el-option label="外卖配送" value="0"></el-option>-->
<!--                    <el-option label="打包自提" value="1"></el-option>-->
<!--                    <el-option label="堂食" value="3"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="" prop="dateType">
                <el-select v-model="queryForm.dateType" placeholder="请选择" class="fl">
                    <el-option label="下单日期" value="1"></el-option>
                    <el-option label="送达日期" value="2"></el-option>
                </el-select>
                <el-date-picker
                        class="fl ml10"
                        v-model="queryForm.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        @change="changeDate()"
                        placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="订单号" prop="orderId">
                <el-input type="text" v-model="queryForm.orderId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="支付方式" prop="payway">
                <el-select v-model="queryForm.payway" placeholder="请选择">
                    <el-option label="微信" value="1"></el-option>
                    <el-option label="支付宝" value="2"></el-option>
                    <el-option label="银联" value="3"></el-option>
                    <el-option label="校园卡" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData(queryForm.pageNo = 1)">查询列表</el-button>
                <el-button type="primary" @click="getSummary()">查询汇总</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <div v-if="summary.totalCost || summary.totalCost === 0">
            <div class="red pb10">说明：此报表未扣除退款订单金额</div>
            <el-card class="box-card mb20" style="background-color: #eaf5fc">
                <el-row>
                    <el-col :span="6">
                        <div>
                            结算金额
                            <div  style="display: inline-block;position: relative">
                                <el-tooltip class="item" effect="dark" content="结算金额＝供货总价－佣金" placement="right">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <p class="red f12">＋<span class="f20 plr2">{{summary.totalIncome || 0}}</span>元</p>
                    </el-col>
                    <el-col :span="6">
                        <div>
                            供货总价
                            <div  style="display: inline-block;position: relative">
                                <el-tooltip class="item" effect="dark" content="供货总价＝供货总价（元）汇总" placement="right">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <p class="red f12">＋<span class="f20 plr2">{{summary.totalCost || 0}}</span>元</p>
                    </el-col>
                    <el-col :span="6">
                        <div>
                            订单总量
                        </div>
                        <p class="red f12"><span class="f20 plr2">{{summary.totalNumber || 0}}</span></p>
                    </el-col>
                    <!--                <el-col :span="6">-->
                    <!--                    <div>-->
                    <!--                        佣金-->
                    <!--                        <div  style="display: inline-block;position: relative">-->
                    <!--                            <el-tooltip class="item" effect="dark" content="佣金＝供货价*佣金率的总和" placement="right">-->
                    <!--                                <i class="el-icon-warning"></i>-->
                    <!--                            </el-tooltip>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <p class="c1cb761 f12"><span class="f20 plr2">{{summary.totalCommission || 0}}</span>元</p>-->
                    <!--                </el-col>-->
                </el-row>
            </el-card>
        </div>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="$apiUrl.financeTransactionBill" :target="'oc'" :field="field" :filename="fileName" :fieldname="fieldName" v-if="showExport"></export-excel>
            <div class="mt10">
                <el-button size="mini" type="primary" @click="downLoadHistoryData()">历史数据下载</el-button>
                <span class="primary f12">如需查询时间跨度大于一周的数据，请使用历史数据下载功能</span>
            </div>
        </el-row>

        <el-tabs v-model="queryForm.orderStatus" @tab-click="getTableData">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="已支付" name="1001"></el-tab-pane>
            <el-tab-pane label="已完成" name="2002"></el-tab-pane>
            <el-tab-pane label="已取消" name="9000"></el-tab-pane>
        </el-tabs>
        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="commercialName"
                    label="公司名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="supplierShortName"
                    label="店铺名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="id"
                    label="订单号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="costAmount"
                    label="供货总价(元)"
                    width="120">
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="commissionRate"-->
<!--                    label="佣金率"-->
<!--                    width="120">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="commission"-->
<!--                    label="佣金(元)"-->
<!--                    width="120">-->
<!--            </el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="deliveryFee"-->
                    <!--label="配送费(元)"-->
                    <!--width="120">-->
            <!--</el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="serviceFee"-->
<!--                    label="服务费(元)"-->
<!--                    width="120">-->
<!--            </el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="packingFee"-->
                    <!--label="环保费(元)"-->
                    <!--width="120">-->
            <!--</el-table-column>-->
            <el-table-column
                    prop="paywayStr"
                    label="支付方式"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="statusCreateTime"
                    label="下单时间"
                    width="170">
                <!--<template slot-scope="scope">-->
                    <!--<span>{{$utils.formatDate(scope.row.statusCreateTime)}}</span>-->
                <!--</template>-->
            </el-table-column>
            <el-table-column
                    prop="deliveryTime"
                    label="送达时间"
                    width="170">
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="orderTypeStr"-->
<!--                    label="配送类型"-->
<!--                    width="120">-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="orderStatus"
                    label="订单状态"
                    :show-overflow-tooltip="true"
                    width="">
                <!--<template slot-scope="scope">-->
                    <!--<span v-if="scope.row.orderStatus==1001">已支付</span>-->
                    <!--<span v-if="scope.row.orderStatus==2002">配送完成</span>-->
                    <!--<span v-if="scope.row.orderStatus==3001">确认收货</span>-->
                    <!--<span v-if="scope.row.orderStatus==9000">已取消</span>-->
                <!--</template>-->
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="120">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="viewDetail(scope.row)">查看</el-button>
                    <el-button size="mini" type="text" @click="viewRecord(scope.row)">配送日志</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
<!--        <el-pagination-->
<!--                @size-change="handleSizeChange"-->
<!--                @current-change="handleCurrentChange"-->
<!--                :current-page="queryForm.pageNo"-->
<!--                :page-sizes="pageSizes"-->
<!--                :page-size="queryForm.pageSize"-->
<!--                layout="total, sizes, prev, pager, next"-->
<!--                :total="total">-->
<!--        </el-pagination>-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            prev-text="上一页"
            next-text="下一页"
            layout="prev, next">
        </el-pagination>

        <!--明细-->
        <el-dialog title="交易明细" :visible.sync="dialogTableVisible">
            <el-table :data="gridData">
                <el-table-column property="title" label="商品名称" width="150"></el-table-column>
                <el-table-column property="costPrice" label="供货价(元)" width="150"></el-table-column>
                <el-table-column property="number" label="数量" width="120"></el-table-column>
                <el-table-column property="commission" label="佣金(元)" width="140"></el-table-column>
                <el-table-column property="costAmount" label="供货总价(元)" width=""></el-table-column>
            </el-table>
        </el-dialog>

        <!--进程状态-->
        <el-dialog title="进程状态" :visible.sync="recordVisible">
            <el-card class="box-card mb15" v-for="r in recordDetail" :key="r.executionTime">
                <p class="bold">{{r.progressInfo}}</p>
                <p>{{r.handlers}} {{r.handlersTel}}</p>
                <p>{{$utils.formatDate(r.executionTime)}}</p>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../components/exportExcel2.vue"
    export default {
        components: {ExportExcel},
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1,
                    startDate: '',
                    endDate: '',
                    dateRange: [],
                    orderId: '',
                    orderStatus: '0',
                    commercial_id: '',
                    shop_id: '',
                    orderType: '',
                    dateType: '1',
                    payway: '',
                    for_report: true
                },

                tableData: [],//表格数据
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果

                commercials: [],
                shops: [],
                shopList: [],
                summary: {},

                //导出
                exportParams: {},
                fileName: '交易数据表',
                fieldName: ['公司名称','店铺名称','订单号','供货总价（元)','环保费（元）','下单时间','订单状态','送达时间'],
                field: ['commercialName','supplierShortName','id','costAmount','packingFee','statusCreateTime','orderStatus','deliveryTime'],
                dialogTableVisible: false,
                gridData: [],

                recordVisible: false,
                recordDetail: {},
                showExport: false
            }
        },
        created(){
            //默认显示最近一周
            if(this.$route.query.date){
                let temp = [];
                temp = this.$route.query.date.split('-');
                this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
            }else{
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.queryForm.dateRange = [day,new Date()];
            }
            this.commercials = JSON.parse(localStorage.getItem('commercials'));
            this.shops = JSON.parse(localStorage.getItem('shops'));
            if(this.$route.params.id){
                this.shopList = this.shops;
                this.queryForm.shop_id = this.$route.params.id.toString();
            }
            this.fetchData();
        },
        methods: {
            changeDate() {
                let range = this.queryForm.dateRange[1] - this.queryForm.dateRange[0];
                if(range > 7*24*3600*1000){
                    this.showExport = false;
                }else{
                    this.showExport = true;
                }
            },
            downLoadHistoryData() {
                this.$router.push({path:`/report/history/data/${this.$route.params.ruleId}`})
            },
            //抓取列表数据
            fetchData() {
                let range = this.queryForm.dateRange[1] - this.queryForm.dateRange[0];
                if(range > 7*24*3600*1000){
                    this.showExport = false;
                    return this.$message.warning('最多只能查询、导出一周的数据');
                }else{
                    this.showExport = true;
                }
                // this.getSummary();
                this.getTableData();
            },
            getParams() {
                let params = {...this.queryForm};
                params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;
                if(params.orderStatus == '0'){
                    params.orderStatus = '';
                }
                return params;
            },
            getSummary() {
                let params = this.getParams();
                delete params.pageSize;
                delete params.pageNo;
                this.$apiJava.post(this.$apiUrl.financeTransactionBillSummary,params,(res)=>{
                    this.summary = res.data;
                },null,'oc')
                // this.$apiJava.post(this.$apiUrl.financeTransactionBillTotal,params,(res)=>{
                //     this.total = res.data.total;
                // },null,'oc')
            },
            getTableData() {
                let params = this.getParams();
                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;

                this.$apiJava.post(this.$apiUrl.financeTransactionBill,params,(res)=>{
                    this.loading = false;
                    // this.total = res.data.total || 0;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
            },
            getShopList() {
                this.queryForm.shop_id = '';
                this.shopList = [];
                this.$api.get(this.$apiUrl.getShopList,{commercial_id: this.queryForm.commercial_id,page: 1,pageSize: 50},(res)=>{
                    if(res.data){
                        for(let k in res.data){
                            this.shopList.push({id:k,name:res.data[k].shop_name});
                        }
                    }else {
                        this.shopList = [];
                    }
                })
            },
            //查看详情
            viewDetail(item) {
                this.dialogTableVisible = true;
                this.$apiJava.get(this.$apiUrl.financeTransactionBillDetail,{orderId:item.id},(res)=>{
                    this.gridData = res.data.goodsList || [];
                },null,'oc')
            },
            remoteShopMethod(query){
                if (query !== '') {
                    this.shopList = [];
                    var arr = [];
                    let len = this.shops.length;
                    var reg = new RegExp(query);
                    for(var i=0;i<len;i++){
                        //如果字符串中不包含目标字符会返回-1
                        if(this.shops[i].name.match(reg)){
                            this.shopList.push(this.shops[i]);
                        }
                    }
                } else {
                    this.shopList = [];
                }
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.queryForm.pageNo = 1;
                this.queryForm.pageSize = 10;
                this.shopList = [];
                this.queryForm.shop_id = '';
                if(this.$route.query.date){
                    let temp = [];
                    temp = this.$route.query.date.split('-');
                    this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
                }else{
                    var day = new Date();
                    day.setTime(day.getTime()-7*24*60*60*1000);
                    this.queryForm.dateRange = [day,new Date()];
                }
                //this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.getTableData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.getTableData();
            },
            //查看记录
            viewRecord(item) {
                let params = {
                    transportCode: item.id,
                    isOrderId: 1
                }
                this.$apiJava.get(this.$apiUrl.transportTurnOverDetail,params,(res)=>{
                    if(res.data && res.data.length > 0){
                        this.recordDetail = res.data;
                        this.recordVisible = true;
                    }else{
                        this.$message.warning('该订单无配送日志');
                    }
                },(res)=>{
                    this.$message.warning(res.msg);
                },'transport')
            },
        }
    }
</script>
<style lang="scss"  scoped>
    .el-card{
        /*border: none;*/
        /*box-shadow: none;*/
    }
</style>


// WEBPACK FOOTER //
// transaction.vue?05965138